import React, { useState } from "react";
import styled from "styled-components";
import { FiMap } from "react-icons/fi";
import { mapImage } from "../../lib/mapImages";

const Box = styled.span<{ $w: number; $h: number }>`
  position: relative;
  flex: 0 0 ${(p) => p.$w}px;
  width: ${(p) => p.$w}px;
  height: ${(p) => p.$h}px;
  display: grid;
  place-items: center;
  overflow: hidden;
  border-radius: 8px;
  background: ${(p) => p.theme.colors.input};
  color: ${(p) => p.theme.colors.textMuted};
  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  svg {
    width: ${(p) => Math.round(p.$h * 0.42)}px;
    height: ${(p) => Math.round(p.$h * 0.42)}px;
  }
`;

/** Миниатюра фактической карты 72×44. Без изображения — нейтральная заглушка, а не чужая карта. */
export default function MapThumb({ map, width = 72, height = 44 }: { map?: string | null; width?: number; height?: number }) {
  const src = mapImage(map);
  const [failed, setFailed] = useState(false);
  return (
    <Box $w={width} $h={height} aria-hidden="true">
      {src && !failed ? <img src={src} alt="" loading="lazy" onError={() => setFailed(true)} /> : <FiMap />}
    </Box>
  );
}
